import React from "react";
import { Loader2, Sparkles } from "lucide-react";
import { WIZARD } from "../../constants/testIds";

export default function RFQAnalysisLoader({ message = "Analyzing your product request..." }) {
  return (
    <div
      data-testid={WIZARD.analysisLoader}
      className="card-panel flex flex-col items-center justify-center py-16 px-8 text-center shadow-glow border-t-4 border-t-[hsl(var(--brand-red))]"
    >
      <div className="relative">
        <div className="w-16 h-16 rounded-full bg-[hsl(var(--brand-navy))]/10 animate-pulse-soft" />
        <div className="absolute inset-0 grid place-items-center">
          <Loader2 className="w-8 h-8 animate-spin text-[hsl(var(--brand-navy))]" />
        </div>
      </div>
      <div className="mt-8 flex items-center justify-center gap-2 text-[hsl(var(--brand-red))]">
        <Sparkles className="w-4 h-4" />
        <p className="text-lg text-[hsl(var(--brand-navy))] tracking-tight font-medium">{message}</p>
      </div>
      <p className="mt-2 text-sm text-neutral-500">This usually takes a few seconds.</p>
    </div>
  );
}
